import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class AdminFactoryService {
  GENERAL_CONFIG: any = {};
  URLS = {
    GET_SERVER_SETTINGS: '/secureConfigSettings',
    RESET_CACHE: '/resetCache',
    SAVE_SYSTEM_SETTINGS: '/saveSystemSetting',
    SAVE_APP_SETTINGS: '/saveAppConfigSetting',
    SAVE_CLIENT_SETTINGS: '/saveClientSystemSetting',
    GET_USER_DETAILS: '/userDetails',
    GET_APP_KEYS: '/getAppKey',
    GET_APP_SETTINGS: '/appConfigSettings',
    GET_CLIENT_SETTINGS: '/clientConfigSettings',
    deleteSystemSetting: '/deleteSystemSetting',
    deleteAppConfigSetting: '/deleteAppConfigSetting',
    deleteClientSystemSetting: '/deleteClientSystemSetting',
  };

  constructor(private http: HttpClient) {
    this.GENERAL_CONFIG = environment;
  }

  setCachedConfigSetting(data: any) {
    const body = new FormData();
    body.append('appKey', data.appKey);
    body.append('clientKey', data.clientKey);
    body.append('clientDatasource', data.clientDatasource);
    body.append('config', data.config);
    return this.http.post(
      this.GENERAL_CONFIG.admin_api_url + this.URLS.RESET_CACHE,
      body,
      { withCredentials: true }
    );
  }

  getConfigSettings(_appKey: any) {
    let params = new HttpParams();
    params = params.append('appKey', _appKey);
    return this.http.get(
      this.GENERAL_CONFIG.base_url + this.URLS.GET_SERVER_SETTINGS,
      { params }
    );
  }

  getAppKeys(clientKey: any) {
    let params = new HttpParams();
    params = params.append('clientKey', clientKey);
    return this.http.get(
      this.GENERAL_CONFIG.base_url + this.URLS.GET_APP_KEYS,
      { params }
    );
  }

  loadAppSettings(clientKey: any, clientDatasource: any, appKey: any) {
    let params = new HttpParams();
    params = params.append('clientKey', clientKey);
    params = params.append('clientDatasource', clientDatasource);
    params = params.append('appKey', appKey);
    return this.http.get(
      this.GENERAL_CONFIG.base_url + this.URLS.GET_APP_SETTINGS,
      { params }
    );
  }

  loadClientSettings(clientKey: any, clientDatasource: any) {
    let params = new HttpParams();
    params = params.append('clientKey', clientKey);
    params = params.append('clientDatasource', clientDatasource);
    return this.http.get(
      this.GENERAL_CONFIG.base_url + this.URLS.GET_CLIENT_SETTINGS,
      { params }
    );
  }

  getuserDetails(_params: any) {
    const body = new FormData();
    body.append('clobData', _params);
    return this.http.post(
      this.GENERAL_CONFIG.base_url + this.URLS.GET_USER_DETAILS,
      body,
      { withCredentials: true }
    );
  }

  saveSystemSetting(data: any, type: any, client: any, appKey: any) {
    let url = '';
    const body = new FormData();
    body.append('key', data.key);
    body.append('value', data.value);
    if (type == 'appconfigSettings') {
      url = this.URLS.SAVE_APP_SETTINGS;
      body.append('clientKey', client.client_key);
      body.append('appKey', appKey);
      body.append('clientDatasource', client.client_datasource);
    } else if (type == 'clientconfigSettings') {
      url = this.URLS.SAVE_CLIENT_SETTINGS;
      body.append('clientKey', client.client_key);
      body.append('clientDatasource', client.client_datasource);
    } else {
      url = this.URLS.SAVE_SYSTEM_SETTINGS;
    }
    return this.http.post(this.GENERAL_CONFIG.base_url + url, body, {
      withCredentials: true,
    });
  }

  deleteSystemSetting(type: any, key: any, client: any, appKey: any) {
    let url = '';
    const body = new FormData();
    body.append('key', key);
    if (type == 'appconfigSettings') {
      url = this.URLS.deleteAppConfigSetting;
      body.append('clientKey', client.client_key);
      body.append('appKey', appKey);
      body.append('clientDatasource', client.client_datasource);
    } else if (type == 'clientconfigSettings') {
      url = this.URLS.deleteClientSystemSetting;
      body.append('clientKey', client.client_key);
      body.append('clientDatasource', client.client_datasource);
    } else {
      url = this.URLS.deleteSystemSetting;
    }
    return this.http.post(this.GENERAL_CONFIG.base_url + url, body, {
      withCredentials: true,
    });
  }
}
